module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('c-images', {
    attrs: {
      "img-items": _vm.imgItems
    }
  })], 1), _vm._v(" "), _c('c-footer', {
    attrs: {
      "horizontal": false
    }
  }, [_c('c-footer', {
    staticClass: "no-border"
  }, [_c('c-title-line', {
    staticClass: "title-full",
    attrs: {
      "title": "选择条数"
    }
  })], 1), _vm._v(" "), _c('c-footer', {
    staticClass: "no-border"
  }, _vm._l((_vm.rechargeMessage), function(item) {
    return _c('c-button-recharge', {
      key: item.id,
      attrs: {
        "title": item.title,
        "desc": item.desc,
        "commend": item.commend
      },
      nativeOn: {
        "click": function($event) {
          _vm.rechargeItemClick(item)
        }
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af4dab5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/details/recharge/message/index.vue
// module id = 1057
// module chunks = 2